
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import InstrumentListMini from "@/components/InstrumentListMini.vue";
    import {auditApi} from "@/api/audit";
    import InstrumentSubmit from "@/components/InstrumentSubmit.vue";
    import html2Canvas from "html2canvas";
    import JsPDF from "jspdf";
    import {checkTypeList} from "@/js/checkType";

    @Component({
        name: "auditDetail",
        components: {InstrumentListMini, InstrumentSubmit}
    })
    export default class Home extends Vue {
        loading = false;
        title = "备案详情";
        pageType = "0";  //0添加  1编辑  2查看
        id = "0";   //id
        listData = [] as any;  //详情返回数据
        form = {
            filingNo: "",
            ownerName: "",
            launchTime: "",
            userName: "",
            userMobile: "",
            promise: [] as any  //自我承诺勾选
        }
        screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
        rules = {
            promise: [{ type: 'array', required: true, message: '提交时，必须勾选“自我承诺   ”', trigger: 'change' }],
            // userName: [{ required: true, message: '请输入发起人', trigger: 'blur' }],
            // userMobile: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        }
        showResult = 0;
        setDialog = false;
        userData = null as any;
        private closePage: any;
        private exportReport: any;
        submitDialog = false;  //弹窗
        submitData = [] as any;  //提交预览
        dialogForm = {} as any; //器具列表搜索条件
        allSelected = [];


        created() {
            this.init();
        }
        init(){
            this.pageType = this.$route.params.type;
            this.id = this.$route.params.id;
            if(this.pageType != "0"){
                this.getDetail();
                this.form.promise = ['1'];
            }else{
                this.getUserData();
            }
        }
        refresh(e:any) {
            this.dialogForm = JSON.parse(JSON.stringify(e));
        }
        //获取登录人数据填入form
        getUserData(){
            this.userData = this.$store.state.AuthedUser;
            this.form.userName = this.userData.name;
            this.form.userMobile = this.userData.phone;
            this.form.ownerName = this.userData.organizationName;
            // this.saveBtn2(2);
        }
        //获取器具详情
        getDetail(){
            auditApi.listOrderDetails({orderId:this.id}).then(r=>{
                if (r.data.result === 0) {
                    const rData = r.data.data;
                    this.listData = rData.instruments;
                    this.form.userName = rData.userName;
                    this.form.userMobile = rData.userMobile;
                    this.form.filingNo = rData.filingNo;
                    this.form.ownerName = rData.ownerName;
                    this.showResult = rData.submitType.value;
                    if(rData.launchTime&&rData.launchTime.length > 10){
                        this.form.launchTime = rData.launchTime.substring(0,10);
                    }
                }
            })
        }
        addList(){
            this.setDialog = true;
            this.$nextTick(()=>{
                const $listData = this.$refs.instrumentList as HTMLFormElement;
                $listData.handleClick();
                $listData.toggleSelection(this.listData);
            })
        }
        removeCheck(){
            const idArr = this.allSelected.flatMap((e: any) => e.id);
            if (idArr.length == 0) {
                this.$message.error("请勾选要移除的器具");
                return;
            }
            const lData = JSON.parse(JSON.stringify(this.listData));
            idArr.forEach((e:any)=>{
                const index = lData.findIndex((e2: any) => e2.id === e);
                if(index !== -1){
                    lData.splice(index, 1);
                }
            })
            this.listData = lData;
            this.allSelected = [];
            this.clearTable();
        }
        saveBtn() {
            const $instrumentList = this.$refs.instrumentList as HTMLFormElement;
            $instrumentList.getCheckData((dataArr: Array<any>) => {
                this.listData = dataArr;
                this.setDialog = false;
            });
        }
        submitBtn(){
            let form = this.$refs.form as HTMLFormElement;
            form.validate((valid:any) => {
                if (valid) {
                    if (this.listData.length == 0) {
                        this.$message.error("器具备案列表不能为空");
                        return;
                    }
                    const ids = this.listData.flatMap((e:any)=>{return e.id});
                    auditApi.getAudit({instrumentIds: ids.join(',')}).then((r:any)=>{
                        if (r.data.result == 0) {
                            const rData = r.data.data;
                            rData.map((e: any) => {
                                e.nameList = [];
                                e.instrumentIds.map((e3: any) => {
                                    const name = this.listData.filter((e2: any) => e2.id == e3)[0].name;
                                    const index = e.nameList.findIndex((e2: any) => e2.name === name);
                                    if (index === -1) {
                                        return e.nameList.push({
                                            name: name,
                                            num: 1
                                        })
                                    } else {
                                        return e.nameList[index].num++;
                                    }
                                })
                            })
                            this.submitData = rData;
                            console.log(this.submitData);
                            this.submitDialog = true;
                        }
                    })

                }else{
                    this.$message.warning("未填写完整信息");
                }
            })
        }
        //type 0 保存  1提交  2新增申请自动保存
        saveBtn2(type: number){
            this.loading = true;
            // let form = this.$refs.form as HTMLFormElement;
            // form.validate((valid:any) => {
            //     if (valid) {
                    const ids = this.listData.flatMap((e:any)=>{return e.id});
                    let params = {
                        instruments: ids.join(","),
                        ...this.form,
                        submitType: type!=2?type:0
                    }
                    // if(this.id != "0"){
                        params = Object.assign(params, {id: this.id});
                    // }
            if(type == 1){
                //如果是提交，增加参数
                params = Object.assign(params, {auditList: this.submitData});
            } else {
                const userData = this.$store.state.AuthedUser;
                const thisSubmitData = [{
                    instrumentIds: ids,
                    mechanism: {
                        id: userData.organizationId,
                        name: userData.organizationName
                    }
                }]
                params = Object.assign(params, {auditList: thisSubmitData});
            }
                    auditApi.submitAuditOrder(params).then(r=>{
                        this.loading = false;
                        if(r.data.result == 0){
                            if(type != 2){
                                this.$message.success("保存成功");
                                this.closePage();
                            }else{
                                const rData = r.data.data;
                                this.form.filingNo = rData.filingNo;
                                this.form.ownerName = rData.ownerName;
                                this.form.launchTime = rData.launchTime;
                                this.form.userName = rData.userName;
                                this.form.userMobile = rData.userMobile;
                                this.id = rData.id;
                                this.pageType = "1";  //变为编辑模式
                            }
                        }
                    })
            //     }
            // })
        }
        clearTable(){
            let $table = this.$refs.table as HTMLFormElement;
            $table.clearSelection();
        }
        downFile() {
            const loading = this.$loading({
                text: '正在导出Excel',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            setTimeout(() => {
                const pdfDom = this.$refs.pdfDom as HTMLFormElement;
                this.exportReport(pdfDom, "计量器具备案申请表", () => {
                    loading.close();
                });
            }, 1000);
        }

        //删除整个任务
        deleteBtn(){
            this.$confirm('确定要删除吗？此操作不可逆转。', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                auditApi.deleteAuditOrder({id: this.id}).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("删除成功");
                        this.closePage();
                    }
                })
            }).catch(() => {
                console.log("取消")
            });
        }
        memberSelectAll(selections: any){
            this.memberSelect(selections);
        }
        memberSelect(selections: any) {
            this.allSelected = selections;
        }
        showCheckTypeStr(e:any){
            let str = "";
            const obj = checkTypeList.find((e2: any)=>e2.id == e.checkType);
            if(obj){
                str = obj.name;
            }else {
                str = '-';
            }
            return str;
        }
        instrDetail(data: any) {
            let id = data.id;
            this.$router.push("/qj/instrument/detail/2/" + id);
        }
    }
